import { RenderOptions } from '../../../common/zoom/models/render-options';
import { CirclePacking } from '../../models/circlePackingModel';
import { FONT_SIZE_VALUE, TEXT_ALIGN_LABEL, TEXT_BASELINE_LABEL, TEXT_LABEL, TEXT_VALUE } from '../constants';

export const textRender: (
  circle: CirclePacking,
  context: CanvasRenderingContext2D,
  lineValue: string,
  renderOptions: RenderOptions
) => void = (circle, context, lineValue, renderOptions) => {
  const fontSize = circle.wrappedText.fontSize;
  const lines = circle.wrappedText.lines;

  const textHeight = (lines.length * fontSize) / 2;
  const halfFontSize = fontSize / 2;

  context.textAlign = TEXT_ALIGN_LABEL;
  context.textBaseline = TEXT_BASELINE_LABEL;

  context.fillStyle = TEXT_LABEL;

  const x = circle.x;
  const baseY = circle.y - textHeight - halfFontSize;

  //  Render labels
  lines.forEach((line, i) => {
    renderLineText(line, fontSize, x, baseY + fontSize * (i + 1), context);
  });

  const noRenderValueForAll = !renderOptions?.text?.applyOnly && !renderOptions?.text?.renderValue;
  const noRenderValueForEach =
    renderOptions?.text?.applyOnly && !renderOptions?.text?.renderValue && renderOptions?.text?.applyOnly.indexOf(circle.id) !== -1;

  if (noRenderValueForAll || noRenderValueForEach) {
    return;
  }
  // Render values
  context.fillStyle = TEXT_VALUE;
  renderLineText(lineValue, fontSize * FONT_SIZE_VALUE, x, baseY + fontSize * (lines.length + 1), context);
};

const renderLineText: (txt: string, fontSize: number, x: number, y: number, context: CanvasRenderingContext2D) => void = (
  txt,
  fontSize,
  x,
  y,
  context
) => {
  context.font = `600 ${fontSize}px "Open Sans"`;
  context.fillText(txt, x, y);
};
